import { Comparison } from "../../../dtos";

export function isSingleSidedOperator(operator: Comparison) {
    return [Comparison.EXISTS, Comparison.DOES_NOT_EXIST, Comparison.IS_TRUE, Comparison.IS_FALSE].includes(operator);
}